// Brand constants & seed data for Saura Energy

export const BRAND = {
  name: "Saura Energy",
  tagline: "Don't just sell solar. Earn trust.",
  blue: "#1B3A8C",
  blueDeep: "#142B6A",
  orange: "#F26A21",
  green: "#2BA84A",
  night: "#0A1128",
  phone: "9862017266",
  phoneDisplay: "+91 98620 17266",
  landline: "0381-291-1229",
  whatsapp: "919862017266",
  address: "Badharghat, near Vivekananda Market, Godown Road, Agartala, Tripura (W) – 799003",
  email: "hello@sauraenergy.solars",
  instagram: "saurasenergy.solars",
  facebook: "Saura Energy Solars",
  logo: "https://customer-assets.emergentagent.com/job_a7c210ce-7b69-4f02-9869-f283b1d5da9b/artifacts/nuws6j8j_Saura%20Energy%20logo%202%20%28W%29.jpg",
  poster1: "https://customer-assets.emergentagent.com/job_a7c210ce-7b69-4f02-9869-f283b1d5da9b/artifacts/w4btopx6_saura%20energy%20poster%2045.jpg",
  poster2: "https://customer-assets.emergentagent.com/job_a7c210ce-7b69-4f02-9869-f283b1d5da9b/artifacts/hlyw2ny6_saura%20energy%20poster01.png",
};

export const IMG = {
  heroDrone: "https://images.unsplash.com/photo-1753781466451-ec9d6029557c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxzb2xhciUyMHBhbmVscyUyMHJvb2Z0b3AlMjBkcm9uZXxlbnwwfHx8fDE3Nzg1MjcwMDB8MA&ixlib=rb-4.1.0&q=85",
  rooftopDrone: "https://images.unsplash.com/photo-1772326281137-b617cbf77c5f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxzb2xhciUyMHBhbmVscyUyMHJvb2Z0b3AlMjBkcm9uZXxlbnwwfHx8fDE3Nzg1MjcwMDB8MA&ixlib=rb-4.1.0&q=85",
  engineers1: "https://images.unsplash.com/photo-1726221062287-fda475b85493?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxzb2xhciUyMHBhbmVsJTIwZW5naW5lZXJzJTIwd29ya2luZ3xlbnwwfHx8fDE3Nzg1MjcwMDB8MA&ixlib=rb-4.1.0&q=85",
  engineers2: "https://images.unsplash.com/photo-1559302504-64aae6ca6b6d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxzb2xhciUyMHBhbmVsJTIwZW5naW5lZXJzJTIwd29ya2luZ3xlbnwwfHx8fDE3Nzg1MjcwMDB8MA&ixlib=rb-4.1.0&q=85",
  residential: "https://images.unsplash.com/flagged/photo-1566838803980-56bfa5300e8c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwzfHxmYW1pbHklMjBob3VzZSUyMHNvbGFyJTIwcGFuZWxzfGVufDB8fHx8MTc3ODUyNzAwMHww&ixlib=rb-4.1.0&q=85",
  residential2: "https://images.unsplash.com/photo-1640802396402-094375631000?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxmYW1pbHklMjBob3VzZSUyMHNvbGFyJTIwcGFuZWxzfGVufDB8fHx8MTc3ODUyNzAwMHww&ixlib=rb-4.1.0&q=85",
  factory1: "https://images.unsplash.com/photo-1745321633881-d2d2218911bd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxmYWN0b3J5JTIwY29tbWVyY2lhbCUyMHNvbGFyJTIwcGFuZWxzfGVufDB8fHx8MTc3ODUyNzAwMHww&ixlib=rb-4.1.0&q=85",
  factory2: "https://images.unsplash.com/photo-1552197892-f2ad2f75e7c8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxmYWN0b3J5JTIwY29tbWVyY2lhbCUyMHNvbGFyJTIwcGFuZWxzfGVufDB8fHx8MTc3ODUyNzAwMHww&ixlib=rb-4.1.0&q=85",
  ev1: "https://images.unsplash.com/photo-1692052664566-477579a08e8c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHxldiUyMGNoYXJnaW5nJTIwc3RhdGlvbiUyMHNvbGFyfGVufDB8fHx8MTc3ODUyNzAwMHww&ixlib=rb-4.1.0&q=85",
  ev2: "https://images.unsplash.com/photo-1652252421025-0392a97129a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxldiUyMGNoYXJnaW5nJTIwc3RhdGlvbiUyMHNvbGFyfGVufDB8fHx8MTc3ODUyNzAwMHww&ixlib=rb-4.1.0&q=85",
  panels: "/ServiceSection/High%20Efficiency%20Solar%20Panels.jpg",
  inverters: "/ServiceSection/Inverter.jpg",
  storage: "/ServiceSection/Energy%20Storage.jpg",
  streetLights: "/ServiceSection/Street%20lights.jpg",
  waterHeater: "/ServiceSection/Water%20heater.jpg",
};

export const SERVICES = [
  {
    slug: "high-efficiency-panels",
    title: "High Efficiency Solar Panels",
    icon: "Home",
    short: "Tier‑1 mono‑PERC and TOPCon panels with industry‑leading efficiency and 25‑year performance.",
    benefits: ["Up to 22% efficiency", "25-year performance warranty", "Low degradation", "High energy yield"],
    image: "panels",
    accent: "orange",
  },
  {
    slug: "premium-inverters",
    title: "Premium Inverters",
    icon: "PlugZap",
    short: "Reliable string and hybrid inverters from top global brands — intelligent, efficient, and serviceable.",
    benefits: ["Smart MPPT tracking", "Hybrid backup ready", "Remote monitoring", "10-year warranty options"],
    image: "inverters",
    accent: "blue",
  },
  {
    slug: "powerful-energy-storage",
    title: "Powerful Energy Storage",
    icon: "BatteryCharging",
    short: "Modular lithium battery systems for backup, time‑shift and peak shaving with safety features.",
    benefits: ["Long cycle life", "Scalable capacity", "24/7 backup", "BMS & safety certified"],
    image: "storage",
    accent: "green",
  },
  {
    slug: "solar-street-lights",
    title: "Solar Street Lights",
    icon: "Building2",
    short: "Durable, autonomous solar street lighting for villages, campuses and roadways — efficient and low‑maintenance.",
    benefits: ["Autonomous operation", "Motion‑aware dimming", "IP65 rated fixtures", "Easy installation"],
    image: "streetLights",
    accent: "blue",
  },
  {
    slug: "solar-water-heater",
    title: "Solar Water Heater",
    icon: "Wrench",
    short: "High‑performance solar water heating systems — roof‑mounted or standing, for homes and institutions.",
    benefits: ["Quick hot water recovery", "Low maintenance", "Corrosion resistant", "Hybrid with electric backup"],
    image: "waterHeater",
    accent: "orange",
  },
];

// Each project owns its own `gallery` array — a dedicated, ordered list of
// image URLs shown when that project's card is clicked. These are TEMPORARY
// stock photos (real solar installs, not staged/lifestyle stock) standing in
// until real installation photographs are available; see README note below
// PROJECTS for exactly how to swap them in.
export const PROJECTS = [
  {
    id: 1,
    title: "120kW Rooftop — Tripura Polytechnic",
    category: "Commercial",
    location: "Agartala, Tripura",
    size: "120 kW",
    image: "factory1",
    year: 2024,
    gallery: [
      IMG.factory1,
      "https://images.unsplash.com/photo-1713544123580-12096cc9eb12?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1698755394258-3c2c3dd9448f?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1631771819642-90cee9a2ccac?auto=format&fit=crop&w=1200&q=80",
    ],
  },
  {
    id: 2,
    title: "50kW Rooftop - Holycross School",
    category: "Commercial",
    location: "Guwahati, Assam",
    size: "5 kW",
    image: "residential",
    year: 2024,
    gallery: [
      IMG.residential,
      "https://images.unsplash.com/photo-1637417494521-78b4d1d33029?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1655300256335-beef51a914fe?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1698755394250-6af71a0fed64?auto=format&fit=crop&w=1200&q=80",
    ],
  },
  {
    id: 3,
    title: "30kW Industrial — Holycross College",
    category: "Industrial",
    location: "Silchar, Assam",
    size: "850 kW",
    image: "factory2",
    year: 2023,
    gallery: [
      IMG.factory2,
      "https://images.unsplash.com/photo-1694327671725-e2a81cda3436?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1589275776107-e193042128bd?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1564151436289-8fc3f8ea6326?auto=format&fit=crop&w=1200&q=80",
    ],
  },
  {
    id: 4,
    title: "8kW Hybrid + Storage",
    category: "Residential",
    location: "Shillong, Meghalaya",
    size: "8 kW",
    image: "residential2",
    year: 2024,
    gallery: [
      IMG.residential2,
      "https://images.unsplash.com/photo-1566838616631-f2618f74a6a2?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1624397640148-949b1732bb0a?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1658298775754-5839ffd434cc?auto=format&fit=crop&w=1200&q=80",
    ],
  },
  {
    id: 5,
    title: "200kW Hospital Rooftop",
    category: "Commercial",
    location: "Agartala, Tripura",
    size: "200 kW",
    image: "engineers2",
    year: 2023,
    gallery: [
      IMG.engineers2,
      "https://images.unsplash.com/photo-1668097613572-40b7c11c8727?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1660330589243-4c640d878052?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1660330589505-9a433a742a7b?auto=format&fit=crop&w=1200&q=80",
    ],
  },
  {
    id: 6,
    title: "Solar EV Charging Hub",
    category: "EV",
    location: "Dimapur, Nagaland",
    size: "60 kW",
    image: "ev1",
    year: 2024,
    gallery: [
      IMG.ev1,
      IMG.ev2,
      "https://images.unsplash.com/photo-1775259928422-779c18e32007?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?auto=format&fit=crop&w=1200&q=80",
    ],
  },
];

// --- Replacing temporary gallery images with real installation photos ---
// 1. Drop your photos in public/images/projects/project-<id>/ (e.g.
//    public/images/projects/project-1/installation-1.jpg).
// 2. Replace the corresponding string(s) in that project's `gallery` array
//    above with "/images/projects/project-1/installation-1.jpg" etc.
// No other file needs to change — the gallery UI reads this array directly.

export const TESTIMONIALS = [
  { name: "Anirban Dey", role: "Homeowner, Agartala", quote: "From subsidy paperwork to net metering, Saura Energy handled everything. My ₹4,200 monthly bill is now ₹380. Honest pricing and brilliant engineers.", rating: 5 },
  { name: "Priya Sharma", role: "MD, Sharma Textiles", quote: "Our 200kW plant paid back in 3.4 years. The O&M team is responsive and the SCADA dashboard makes monitoring effortless.", rating: 5 },
  { name: "Dr. Rakesh Bhattacharya", role: "Chairman, Bhattacharya Hospitals", quote: "A hospital can't afford downtime. Saura's hybrid system with battery backup has been flawless for 18 months running.", rating: 5 },
  { name: "Mohan Lal", role: "Tea Estate Owner", quote: "850kW commissioned in 9 weeks. Quality of execution rivals any tier-1 EPC. Highly recommended for industrial loads.", rating: 5 },
];

export const PROCESS_STEPS = [
  { n: 1, title: "Consultation", desc: "Free expert advice on system sizing, subsidy & ROI.", icon: "MessageSquare" },
  { n: 2, title: "Site Survey", desc: "On-site shadow, structural & DISCOM feasibility check.", icon: "MapPin" },
  { n: 3, title: "Design", desc: "Tier-1 panel layout, single-line diagrams, BoQ.", icon: "Ruler" },
  { n: 4, title: "Approval", desc: "DISCOM application + subsidy registration on PM Surya Ghar.", icon: "FileCheck2" },
  { n: 5, title: "Installation", desc: "Certified engineers install in 7–14 days.", icon: "Hammer" },
  { n: 6, title: "Activation", desc: "Net meter installation & commissioning.", icon: "Zap" },
  { n: 7, title: "Support", desc: "Lifetime helpdesk + annual performance reports.", icon: "ShieldCheck" },
];

export const WHY_CHOOSE = [
  { title: "25-Year Warranty", desc: "Premium panels backed by manufacturer guarantee.", icon: "ShieldCheck" },
  { title: "Expert Engineers", desc: "MNRE-certified team with 500+ installations.", icon: "Users" },
  { title: "Government Subsidy", desc: "Up to ₹85,800 instant subsidy via PM Surya Ghar.", icon: "Award" },
  { title: "Fast Installation", desc: "7–14 day residential rollouts. Industrial in 6–10 weeks.", icon: "Rocket" },
  { title: "Maintenance Support", desc: "24/7 helpdesk + quarterly cleaning included.", icon: "Wrench" },
  { title: "Easy Financing", desc: "Loans @ 5.75% via SBI, PNB, BOB & Canara.", icon: "Landmark" },
  { title: "High Efficiency Panels", desc: "Tier-1 mono-PERC and TOPCon up to 22% efficiency.", icon: "Sun" },
  { title: "Transparent Pricing", desc: "Itemised quotes. No hidden costs. Ever.", icon: "ReceiptText" },
];

export const PARTNERS = [
  { name: "Tata Power Solar", logo: "/partners/tata.png" },
  { name: "Adani Solar", logo: "/partners/adani.png" },
  { name: "Waaree", logo: "/partners/waaree.png" },
  { name: "Luminous", logo: "/partners/luminous.png" },
  { name: "Rayzon", logo: "/partners/rayzon.png" },
  { name: "UTL", logo: "/partners/utl.png" },
  { name: "K Solare", logo: "/partners/ksolare.png" },
  { name: "Loom", logo: "/partners/loom.png" },
];

export const BANKS = ["SBI", "PNB", "Bank of Baroda", "Canara Bank", "HDFC", "ICICI"];

export const BLOG_POSTS = [
  { id: 1, title: "PM Surya Ghar 2025: How to Claim ₹85,800 Subsidy in 7 Days", excerpt: "A step-by-step guide for Indian homeowners to register, install, and claim residential rooftop solar subsidy.", date: "Feb 2026", category: "Subsidy", image: "residential" },
  { id: 2, title: "Mono-PERC vs TOPCon: Which Panel is Right for Your Rooftop?", excerpt: "We break down efficiency, degradation, price-per-watt and warranty for India's most popular panel technologies.", date: "Jan 2026", category: "Education", image: "engineers1" },
  { id: 3, title: "Solar + Battery Storage: Is It Worth It in 2026?", excerpt: "When hybrid systems pay back, when they don't, and the new lithium chemistries to watch.", date: "Jan 2026", category: "Trends", image: "residential2" },
  { id: 4, title: "Commercial Solar ROI: Real Numbers from 14 Tripura Businesses", excerpt: "Anonymised case studies showing payback periods, IRR and 25-year savings for SME installations.", date: "Dec 2025", category: "Case Study", image: "factory1" },
];

export const FAQS = [
  { q: "How much does a 3kW residential solar system cost in India?", a: "Approximately ₹1.8 lakh before subsidy. After PM Surya Ghar subsidy of ₹78,000, your net investment is around ₹1.02 lakh — typically paid back in 4–5 years." },
  { q: "Will solar work during power cuts?", a: "Grid-tied systems shut off for safety during outages. To run during cuts, you need a hybrid system with battery storage — which Saura Energy designs end-to-end." },
  { q: "Is rooftop solar maintenance heavy?", a: "Not at all. Panels need cleaning once every 2–3 months and an annual electrical check. Our O&M plans cover both." },
  { q: "How long does installation take?", a: "Residential: 7–14 days after DISCOM approval. Commercial: 4–8 weeks. Industrial: 6–14 weeks depending on scale." },
  { q: "What if my roof is shaded?", a: "We perform a shadow analysis. Where partial shading exists, we use micro-inverters or DC optimisers so a single shaded panel doesn't drag the whole string." },
  { q: "How do I claim the government subsidy?", a: "We register your application on the national PM Surya Ghar portal, handle DISCOM inspection, and ensure the subsidy lands directly in your bank account — usually within 30 days of commissioning." },
];

export const STATS = [
  { label: "Homes Powered", value: 1240, suffix: "+" },
  { label: "MW Installed", value: 18.6, decimals: 1, suffix: "" },
  { label: "CO₂ Saved (Tonnes)", value: 22480, suffix: "+" },
  { label: "Happy Clients", value: 980, suffix: "+" },
];
